<div class="filters-container">

  <div class="filter-item">
    <label>FUENTE DE EMISIÓN</label>
    <select [(ngModel)]="filtro.variations">
      <option *ngFor="let v of variationOptions" [value]="v.key">{{ v.label }}</option>
    </select>
  </div>

  <div class="filter-item filter-small">
    <label>PCG</label>
    <select [(ngModel)]="filtro.pcg">
      <option *ngFor="let p of pcg" [value]="p">{{ p }}</option>
    </select>
  </div>

  <div class="filter-item filter-small">
    <label>AÑO</label>
    <select [(ngModel)]="filtro.year">
      <option *ngFor="let y of year" [value]="y">{{ y }}</option>
    </select>
  </div>

  <div class="filter-item filter-mode">
    <label>MODO</label>
    <div class="toggle-group" role="tablist" aria-label="Modo filtro">
      <button
        type="button"
        class="toggle-btn"
        [class.active]="filtro.mode === 'categoria'"
        (click)="setMode('categoria')"
        aria-pressed="{{ filtro.mode === 'categoria' }}">
        Categoría
      </button>
      <button
        type="button"
        class="toggle-btn"
        [class.active]="filtro.mode === 'alcance'"
        (click)="setMode('alcance')"
        aria-pressed="{{ filtro.mode === 'alcance' }}">
        Alcance
      </button>
    </div>
  </div>

  <div class="filter-item">
    <label>{{ filtro.mode === 'categoria' ? 'CATEGORÍA' : 'ALCANCE' }}</label>
    <select [(ngModel)]="filtro.alcance">
      <option *ngFor="let a of (filtro.mode === 'categoria' ? categorias : alcances)" [value]="a">{{ a }}</option>
    </select>
  </div>

  <div class="filter-actions">
    <button class="btn-primary" (click)="onApply()">Aplicar</button>
    <button class="btn-secondary" (click)="onClear()">Limpiar</button>
  </div>
</div>